import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { LibraryRoutes } from './library.route';
import { TabsModule } from 'ngx-bootstrap/tabs';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LibraryComponent } from './library.component';
import { HttpClientModule } from '@angular/common/http';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedUIModule } from '../shared/shared-ui.module';
import { AuthGuard } from '../../core/services/auth/auth.guard';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RuleTreeComponent } from './rule-tree/rule-tree.component';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { GDPRService } from './../../core/services/rulebook/gdpr.service';
import { RegulationService } from 'src/app/core/services/regulation';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RuleHierarchyComponent } from './rule-hierarchy/rule-hierarchy.component';
import { AnalyticsService } from './../../core/services/analytics/analytics.service';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { RulebookDashboardComponent } from './rulebook-dashboard/rulebook-dashboard.component';
// import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ReportingTemplatesComponent } from './reporting-templates/reporting-templates.component';
import { RulesConnectionComponent } from './rules-connection/rules-connection.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import {TableModule} from 'primeng/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipModule } from 'primeng/tooltip';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule.forChild(LibraryRoutes),
    DistributedUIModule,
    TooltipModule,
    BsDropdownModule,
    TabsModule,
    CollapseModule,
    ScrollingModule,
    SharedUIModule,
    NgxPowerBiModule,
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatChipsModule,
    MatSlideToggleModule,
    NgSelectModule,
    FormsModule ,
    MatPaginatorModule,
    TableModule,
    MatTooltipModule
  ],
  providers: [
    AuthGuard,
    SessionService,
    AuthService,
    AnalyticsService,
    GDPRService,
    RegulationService
  ],
  declarations: [
    LibraryComponent,
    RuleHierarchyComponent,
    RuleTreeComponent,
    RulebookDashboardComponent,
    ReportingTemplatesComponent,
    RulesConnectionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LibraryModule { }
